module.exports = __webpack_public_path__ + "static/media/before_image.ace24f6c.png";